import EstimatedAt from './EstimatedAt';

export default EstimatedAt;
